import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { VideoPlayer as _VideoPlayer } from "~/components/blocks/common/video-player";
import { DETAIL_HEADER_ASPECT_RATIO } from "~/components/stores/detail-product/style";
import { Z_INDEX } from "~/styles/z-index";

export const DivVideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const PictureVideoPosition = styled.picture`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;

  ::before {
    content: "";
    display: block;
    width: 100%;
    padding-top: ${DETAIL_HEADER_ASPECT_RATIO}%;
  }
`;

export const SampleVideoPlayer = styled(_VideoPlayer)`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: initial; // memo:作品末端用にstyleを上書き
  height: 100%;
`;

export const ButtonAudioSwitch = styled.button`
  display: block;
  position: absolute;
  bottom: 12px;
  left: 16px;
  padding: 8px;
  // Overlay よりも MuteButton を上に表示するために指定する
  z-index: ${Z_INDEX.HEADER - 5};

  ${mq.sp} {
    bottom: 20px;
    left: 20px;
  }
`;
